import { DAYS, formatTime, toLocalDateStr, isSameDay, isEventPast, workshopsForDate } from "./calendarUtils";
import { EventPill, WorkshopBanner } from "./CalendarPills";

export function MonthView({ calendarCells, today, adminMode, getVisibleClasses, getPublicClasses,
  renderWorkshopBanners, setSelectedEvent, setSelectedDate }) {
  return (
    <div className="cal-grid">
      <div className="day-headers">{DAYS.map(d=><div key={d} className="day-header">{d}</div>)}</div>
      <div className="month-grid">
        {calendarCells.map((date,i)=>{
          if(!date) return <div key={`e-${i}`} className="day-cell empty"/>;
          const isToday = isSameDay(date, today);
          const evts = adminMode ? getVisibleClasses(date) : getPublicClasses(date);
          return (
            <div key={date.toISOString()} className={`day-cell ${isToday?"today":""}`}>
              <span className="day-num">{date.getDate()}</span>
              {renderWorkshopBanners(date)}
              {evts.map(evt=>(
                <EventPill key={evt.id} event={evt} compact={true}
                  adminMode={adminMode} cancelled={evt._cancelled}
                  dateStr={toLocalDateStr(date)}
                  onClick={e=>{setSelectedEvent(e);setSelectedDate(date);}} />
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function WeekView({ weekDates, today, adminMode, getVisibleClasses, getPublicClasses,
  workshops, setSelectedEvent, setSelectedDate, setSelectedWorkshop }) {
  return (
    <div className="week-grid">
      {weekDates.map(date=>{
        const evts    = adminMode ? getVisibleClasses(date) : getPublicClasses(date);
        const dateStr = toLocalDateStr(date);
        const wsForDay = workshopsForDate(dateStr, workshops);
        const isToday = isSameDay(date, today);
        return (
          <div key={date.toISOString()} className={`week-col ${isToday?"today":""}`}>
            <div className="week-col-header">
              <span className="week-day-name">{DAYS[date.getDay()]}</span>
              <span className="week-day-num">{date.getDate()}</span>
            </div>
            {wsForDay.map(w => (
              <WorkshopBanner key={w.id} workshop={w} dateStr={dateStr} onClick={setSelectedWorkshop} adminMode={adminMode} />
            ))}
            {evts.map(evt => {
              const past = !adminMode && isEventPast(dateStr, evt.time, evt.duration);
              if (evt._isPrivate) {
                return (
                  <div key={evt.id}
                    className="week-event-pill private-pill"
                    style={{ cursor: adminMode ? "pointer" : "default" }}
                    onClick={() => { if (adminMode) { setSelectedEvent(evt); setSelectedDate(date); } }}>
                    <span className="week-event-time">{formatTime(evt.time)}</span>
                    <span className="week-event-label">{adminMode ? "Private" : "Private — n/a"}</span>
                  </div>
                );
              }
              return (
                <button key={evt.id}
                  className={`week-event-pill ${evt.isHybrid?"hybrid":evt.venue==="venue_online"?"online":"inperson"} ${evt._cancelled?"cancelled-pill":""} ${past && !adminMode?"past-pill":""}`}
                  onClick={() => { if (past && !adminMode) return; setSelectedEvent(evt); setSelectedDate(date); }}>
                  <span className="week-event-time">{formatTime(evt.time)}</span>
                  <span className="week-event-label">{evt._cancelled?"Cancelled":evt.venue==="venue_online"?"Online":"Studio"}</span>
                </button>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}

export function DayView({ focusDay, adminMode, getVisibleClasses, getPublicClasses,
  workshops, setSelectedEvent, setSelectedDate, setSelectedWorkshop }) {
  const dateStr  = toLocalDateStr(focusDay);
  const evts     = adminMode ? getVisibleClasses(focusDay) : getPublicClasses(focusDay);
  const wsForDay = workshopsForDate(dateStr, workshops);
  const isEmpty  = evts.length === 0 && wsForDay.length === 0;

  return (
    <div className="day-view">
      <div className="day-view-date">
        {focusDay.toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"})}
      </div>
      {wsForDay.map(w=>(
        <button key={w.id} className="day-workshop-card" onClick={()=>setSelectedWorkshop(w)}>
          <div className="day-event-time-col" style={{color:"var(--color-workshop)"}}>Workshop</div>
          <div className="day-event-info">
            <span className="day-event-title">{w.title}</span>
            <span className="day-event-sub">
              {w.days.find(d=>d.date===dateStr)?.sessions.map(s=>`${s.label} ${formatTime(s.time)}`).join(" · ")}
            </span>
          </div>
        </button>
      ))}
      {isEmpty && <p className="no-classes">No classes scheduled today.</p>}
      {evts.map(evt => {
        const past = !adminMode && isEventPast(dateStr, evt.time, evt.duration);
        if (evt._isPrivate) {
          return (
            <div key={evt.id}
              className="day-event-card private-pill"
              style={{ cursor: adminMode ? "pointer" : "default" }}
              onClick={() => { if (adminMode) { setSelectedEvent(evt); setSelectedDate(focusDay); } }}>
              <div className="day-event-time-col">{formatTime(evt.time)}</div>
              <div className="day-event-info">
                <span className="day-event-title">{adminMode ? "Private Class" : "Private Class — not available"}</span>
              </div>
            </div>
          );
        }
        return (
          <button key={evt.id}
            className={`day-event-card ${evt.isHybrid?"hybrid":evt.venue==="venue_online"?"online":"inperson"} ${evt._cancelled?"cancelled-pill":""} ${past?"past-pill":""}`}
            onClick={() => { if (past && !adminMode) return; setSelectedEvent(evt); setSelectedDate(focusDay); }}>
            <div className="day-event-time-col">{formatTime(evt.time)}</div>
            <div className="day-event-info">
              <span className="day-event-title">
                {evt.title}{evt._cancelled&&<span className="cancelled-label"> — Cancelled</span>}
              </span>
              <span className="day-event-sub">
                {evt.duration} min · {evt.teacher} · {evt.venue==="venue_online"?"Online":"Journey into Fitness"}
              </span>
            </div>
          </button>
        );
      })}
    </div>
  );
}